import { useEffect } from "react";

export default function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Kurtaani` : "Kurtaani – Cotton Kurtis, Anarkali Suits & Festive Wear for Women";
    let m = document.querySelector('meta[name="description"]');
    if (!m) {
      m = document.createElement("meta");
      m.name = "description";
      document.head.appendChild(m);
    }
    m.content = description || "Shop breathable cotton kurtis, Anarkali suits, straight kurtis and festive wear for women. Free shipping across India, COD and easy size exchange.";
    window.scrollTo({ top: 0 });
  }, [title, description]);
}
